module.exports = __webpack_public_path__ + "static/img/img_home_clw.df36bcdc.png";